import React from 'react';
import styles from './Distributor.module.scss';
import api from "../../../helpers/api";
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import { $t } from "../../../helpers/translator";
import DistributorDetails from "../../../components/DistributorDetails/DistributorDetails";
import DistributorErrorEmailAlerts from "../../../components/DistributorErrorEmailAlerts/DistributorErrorEmailAlerts";
import PlatformsTable from "../../../components/PlatformsTable/PlatformsTable";
import ApplicatorsTable from "../../../components/ApplicatorsTable/ApplicatorsTable";
import ClinicsTable from "../../../components/ClinicsTable/ClinicsTable";
import Loader from '../../../components/miscellaneous/Loader/Loader';
import HasPermission from 'helpers/permissions/HasPermission';
import UsersTable from "../../../components/UsersTable/UsersTable";

const DistributorPage = (props) => {
    const [ distributor, setDistributor ] = React.useState(null);

    React.useEffect(() => {
        if (props.match.params.id) {
            getDistributor(props.match.params.id);
        }
    }, []);

    const getDistributor = async (id) => {
        let res = await api.get(`/distributor/${id}`);

        if (res.status !== 200) {
            return;
        }

        // console.log(res.data.data)
        setDistributor(res.data.data);
    }

    return (
        <div className={ styles.container }>
            <HasPermission permission="distributor.view">
                { distributor ? <><div className={ ` ${styles.clinicNameContainer}` }>
                    { distributor.name }
                </div>

                    <div className={ styles[ 'flex-row' ] }>
                        <div className={ styles[ 'box' ] }>
                            <AccountDetails distributorId={distributor.id} userId={ distributor.userId } userType={ 5 } />
                        </div>
                        <div className={ styles[ 'box' ] }>
                            <DistributorDetails userType={ 5 } distributorId={ distributor.id } />
                        </div>
                        <div className={ styles[ 'box' ] }>
                            <DistributorErrorEmailAlerts userType={ 5 } distributorId={ distributor.id } />
                        </div>
                    </div>

                    <div>
                        <div className={ styles[ 'flex-row' ] }>
                            <div className={ styles[ 'box' ] }>
                                <ClinicsTable userType={ 5 } distributorId={ distributor.id } header={ $t('global.clinics.clinicsAndChains') } />
                            </div>
                        </div>
                        <div className='d-flex' style={ { flexWrap: 'wrap' } }>
                            <div className={ styles[ 'flex-row-half' ] }>
                                <div className={ styles[ 'box' ] }>
                                    <PlatformsTable userType={ 5 } distributorId={ distributor.id } perPage={ 10 } getUsage={ false } />
                                </div>
                            </div>
                            <div className={ styles[ 'flex-row-half' ] }>
                                <div className={ styles[ 'box' ] }>
                                    <ApplicatorsTable userType={ 5 } distributorId={ distributor.id } perPage={ 10 } />
                                </div>
                            </div>
                            <div className={styles['flex-row']}>
                                <div className={styles['box']}>
                                    <UsersTable userType={5} distributorId={distributor.id}/>
                                </div>
                            </div>
                        </div>

                    </div></> : <Loader /> }
            </HasPermission>
        </div>
    );
}

export default DistributorPage;
